<div [ngStyle]="{width: size + 'px', height: size + 'px'}" class="db-progress-spinner db-progress-spinner_type_{{type}}">
  <span class="db-progress-spinner__part db-progress-spinner__part_left">
    <span [ngStyle]="{borderWidth: strokeWidth + 'px'}"></span>
    <span [ngStyle]="{transform: 'rotate(' + leftMaskRotation + 'deg)'}"></span>
  </span>
  <span class="db-progress-spinner__part db-progress-spinner__part_right">
    <span [ngStyle]="{borderWidth: strokeWidth + 'px'}"></span>
    <span [ngStyle]="{transform: 'rotate(' + rightMaskRotation + 'deg)'}"></span>
  </span>

  <span class="db-progress-spinner__percent"><span *ngIf="showPercent">{{progressPercent | DbNumberParseIntPipe}}%</span></span>
</div>
